import { FC } from 'react';
import { PageHeader } from '@sim-admin-frontends/ui-shared';
import { useTranslation } from 'react-i18next';

import { PageWrapper } from '../../components/layout/PageLayout';
import { SelectorsViewContainer } from '../../components/selectors/view/SelectorsView.container';

const TaskListPage: FC = () => {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <PageHeader title={t('selectors.pageTitle')} caption={t('selectors.pageCaption')} />
      <SelectorsViewContainer />
    </PageWrapper>
  );
};

export default TaskListPage;
